import { inject, provideAppInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

function registerIcons(matIcon: MatIconRegistry, sanitizer: DomSanitizer): void {
  matIcon.addSvgIconLiteral(
    'info-outline',
    sanitizer.bypassSecurityTrustHtml(
      `<svg style='width:24px;height:24px' viewBox='0 0 24 24'>
        <path d='M0 0h24v24H0V0z' fill='none'/>
        <path d='M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8
        8-3.59 8-8 8z'/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'barley',
    sanitizer.bypassSecurityTrustHtml(
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="currentColor" d="M7.33,18.33C6.5,17.17 6.5,15.83 6.5,14.5C8.17,15.5 9.83,16.5 10.67,17.67L11,18.23V15.95
          C9.5,15.05 8.08,14.13 7.33,13.08C6.5,11.92 6.5,10.58 6.5,9.25C8.17,10.25 9.83,11.25 10.67,12.42L11,13V10.7
          C9.5,9.8 8.08,8.88 7.33,7.83C6.5,6.67 6.5,5.33 6.5,4C8.17,5 9.83,6 10.67,7.17C10.77,7.31 10.86,7.46 10.94,7.62
          C10.77,7 10.66,6.42 10.65,5.82C10.64,4.31 11.3,2.76 11.96,1.21C12.65,2.69 13.34,4.18 13.35,5.69
          C13.36,6.32 13.25,6.96 13.07,7.59C13.15,7.45 13.23,7.31 13.33,7.17C14.17,6 15.83,5 17.5,4
          C17.5,5.33 17.5,6.67 16.67,7.83C15.92,8.88 14.5,9.8 13,10.7V13L13.33,12.42C14.17,11.25 15.83,10.25 17.5,9.25
          C17.5,10.58 17.5,11.92 16.67,13.08C15.92,14.13 14.5,15.05 13,15.95V18.23L13.33,17.67
          C14.17,16.5 15.83,15.5 17.5,14.5C17.5,15.83 17.5,17.17 16.67,18.33C15.92,19.38 14.5,20.3 13,21.2V23H11V21.2
          C9.5,20.3 8.08,19.38 7.33,18.33Z"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'database-outline',
    sanitizer.bypassSecurityTrustHtml(
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="currentColor" d="M12 3C7.58 3 4 4.79 4 7V17C4 19.21 7.59 21 12 21S20 19.21 20 17V7
          C20 4.79 16.42 3 12 3M18 17C18 17.5 15.87 19 12 19S6 17.5 6 17V14.77C7.61 15.55 9.72 16 12 16S16.39 15.55 18 14.77V17
          M18 12.45C16.7 13.4 14.42 14 12 14C9.58 14 7.3 13.4 6 12.45V9.64C7.47 10.47 9.61 11 12 11C14.39 11 16.53 10.47 18 9.64V12.45
          M12 9C8.13 9 6 7.5 6 7S8.13 5 12 5C15.87 5 18 6.5 18 7S15.87 9 12 9Z"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'newspaper-variant-outline',
    sanitizer.bypassSecurityTrustHtml(
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="currentColor" d="M20 5L20 19L4 19L4 5H20M20 3H4C2.89 3 2 3.89 2 5V19C2 20.11 2.89 21 4 21H20
          C21.11 21 22 20.11 22 19V5C22 3.89 21.11 3 20 3M18 15H6V17H18V15M10 7H6V13H10V7M12 9H18V7H12V9M18 11H12V13H18V11Z"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'truck-delivery-outline',
    sanitizer.bypassSecurityTrustHtml(
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path fill="currentColor" d="M18 18.5C18.83 18.5 19.5 17.83 19.5 17C19.5 16.17 18.83 15.5 18 15.5
          C17.17 15.5 16.5 16.17 16.5 17C16.5 17.83 17.17 18.5 18 18.5M19.5 9.5H17V12H21.46L19.5 9.5
          M6 18.5C6.83 18.5 7.5 17.83 7.5 17C7.5 16.17 6.83 15.5 6 15.5C5.17 15.5 4.5 16.17 4.5 17C4.5 17.83 5.17 18.5 6 18.5
          M20 8L23 12V17H21C21 18.66 19.66 20 18 20C16.34 20 15 18.66 15 17H9C9 18.66 7.66 20 6 20C4.34 20 3 18.66 3 17H1V6
          C1 4.89 1.89 4 3 4H17V8H20M3 6V15H3.76C4.31 14.39 5.11 14 6 14C6.89 14 7.69 14.39 8.24 15H15V6H3M10 7L13.5 10.5L10 14V11.5H5V9.5H10V7Z"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'link-variant',
    sanitizer.bypassSecurityTrustHtml(
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path d="M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76
          L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36
          L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41
          M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78
          C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36
          C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'twig',
    sanitizer.bypassSecurityTrustHtml(
      `<svg viewBox="0 0 32 32" height="100%" width="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M13.9142465,17.4414782 C13.453207,17.2478236 12.9517008,17.1124213 12.4227458,17.0824804
          C9.98662126,16.9445866 7.87224903,19.0896019 7.87224903,19.0896019 C7.87224903,19.0896019 9.72615511,21.4644402 12.1622796,21.6023341
          C13.9441486,21.7025642 15.5398358,20.5966606 16.2785809,19.9850599 C17.3110656,21.0592951 18.2811501,22.0167331 19.2105216,22.8826379
          C18.5531767,22.4814954 17.7685594,22.1564318 16.9119564,22.1079448 C14.4605103,21.970051 12.3614596,24.1150663 12.3614596,24.1150663
          C12.3614596,24.1150663 14.2153657,26.4899047 16.6514902,26.6277985 C18.9720967,26.7583326 20.9769204,24.8431431 21.1843144,24.6383348
          C23.7364079,26.7979358 26.0796478,28.3446109 28.7401836,29.8912861 C28.8167913,29.9372507 28.8933989,29.9525722 28.9700066,29.9525722
          C29.123222,29.9525722 29.2764374,29.8759645 29.3683666,29.7227491 C29.4909389,29.5082476 29.4143312,29.2171384 29.1998297,29.0945661
          C26.5289188,27.5451784 24.184422,25.9930478 21.6115735,23.7963634 C22.2825454,23.16602 23.6567702,21.6608423 23.7606838,19.8250357
          C23.8985776,17.3889112 21.7535623,15.274539 21.7535623,15.274539 C21.7535623,15.274539 19.378724,17.128445 19.2408301,19.5645696
          C19.1837702,20.5726284 19.5176064,21.5255944 19.9286064,22.296455 C18.9933845,21.4287669 18.016429,20.4670085 16.9745696,19.3843739
          C17.5858403,18.8331356 19.130418,17.2557968 19.2408301,15.305182 C19.378724,12.8690575 17.2337087,10.7546853 17.2337087,10.7546853
          C17.2337087,10.7546853 14.8588703,12.5932698 14.7209764,15.0447159 C14.667136,15.9958977 14.9613255,16.8980283 15.3399774,17.6444038
          C14.4309721,16.6551039 13.4708975,15.576206 12.4471474,14.393126 C13.0293612,13.8755123 14.6388269,12.2723875 14.7516195,10.2797176
          C14.8895134,7.82827157 12.7444981,5.72922088 12.7444981,5.72922088 C12.7444981,5.72922088 10.3696597,7.58312696 10.2317659,10.0192515
          C10.1831404,10.8783006 10.4183891,11.6973407 10.7433535,12.3977678 C10.1973301,11.7504097 9.63381407,11.0752357 9.0512451,10.3704406
          C9.0750574,9.38797151 8.94935854,7.51605402 7.81096288,6.20418855 C6.20220141,4.35028248 3.19917999,4.33496094 3.19917999,4.33496094
          C3.19917999,4.33496094 2.78549847,7.32266082 4.39425994,9.16124536 C5.54277283,10.4847697 7.40189712,10.8712241 8.3716442,10.9840184
          C8.8135703,11.5190827 9.24469747,12.0372325 9.66569385,12.5392463 C9.14046306,12.2888531 8.55600527,12.1075717 7.93353518,12.0723375
          C5.49741067,11.9344437 3.39835998,14.079459 3.39835998,14.079459 C3.39835998,14.079459 5.25226606,16.4542974 7.68839058,16.5921912
          C9.43542873,16.6910802 11.0091141,15.6158979 11.7596029,14.9997299 C12.5097644,15.8670646 13.2263693,16.6791056 13.9142465,17.4414782 Z"
          transform="matrix(-1 0 0 1 32.578 0)"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'cow',
    sanitizer.bypassSecurityTrustHtml(
      `<svg viewBox="0 0 32 32" height="100%" width="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M14.8087149,4.54875482 C20.1604274,2.38426382 22.7491534,6.87111112 24.5387539,9.75167952
          C26.4141602,12.7703624 30.3693441,14.1616895 30.3693441,14.1616895 C30.9944795,17.6027395 28.0851953,20.3978163 25.7890248,19.751843
          C24.2884778,19.3296996 21.904871,18.3133733 19.9097921,18.7691662 C17.1550798,18.610802 15.101613,17.0954905 15.101613,14.9691561
          C15.101613,14.74555 14.8972418,14.5592115 14.8972418,14.5592115 C14.8972418,14.5592115 14.5966959,14.74555 14.5966959,14.9691561
          C14.5966959,17.1849029 16.1080331,18.8504082 18.5176624,19.4105605 C18.0306039,19.7811744 17.5996736,20.3100655 17.2535216,21.0437896
          C15.3781152,25.0190098 13.5027089,30.1867962 13.5027089,30.1867962 C5.49616647,30.6215859 -0.550816777,19.5406594 1.52896076,11.0436261
          C6.49205856,10.5921967 8.75874905,9.11354413 10.5046921,7.6267042 C9.01089594,6.64840809 7.64807502,5.28203723 7.64807502,3.55282042
          C10.115839,1.0129168 13.0701952,1.77014114 14.8087149,4.54875482 Z M20.3791988,11.7889799
          C21.009949,11.7889799 21.5212732,11.2606117 21.5212732,10.6088364 C21.5212732,9.95706112 21.009949,9.42869287 20.3791988,9.42869287
          C19.7484485,9.42869287 19.2371244,9.95706112 19.2371244,10.6088364 C19.2371244,11.2606117 19.7484485,11.7889799 20.3791988,11.7889799 Z"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'poultry',
    sanitizer.bypassSecurityTrustHtml(
      `<svg viewBox="0 0 32 32" height="100%" width="100%" preserveAspectRatio="xMidYMid meet">
        <path d="M23.2374935,11.7940853 C24.1014629,13.2084184 24.6546402,14.5093618 24.3946133,15.856774
          C26.2224324,17.1795379 27.9300003,19.392161 27.9300003,21.6528846 C25.7414274,20.6908746 23.4807038,20.6187238 21.9414877,22.2060404
          C21.3642816,22.8072967 20.2339198,25.3566234 20.1377188,25.6211762 C19.776965,26.6072365 19.199759,27.3768445 19.3440605,28.3869551
          L4,28.5072063 C7.41082204,22.9258612 9.02384972,16.8714122 11.5839145,11.8453058 L11.6076832,11.5668722
          C11.0121886,11.0298563 10.6378694,10.2522698 10.6378694,9.38725635 C10.6378694,7.76678072 11.9515245,6.45312566 13.5720001,6.45312566
          C13.8807483,6.45312566 14.1783585,6.50081324 14.4578669,6.58922463 C14.6285835,5.13128279 15.8681491,4 17.3719399,4
          C18.7310823,4 19.874386,4.92411554 20.2077975,6.17829322 C20.3507375,6.37131813 20.5069001,6.5138812 20.6738174,6.61420936
          C20.9736447,6.50988424 21.2950477,6.45312566 21.6288344,6.45312566 C23.2642515,6.45312566 24.1541108,7.82399 24.5629651,9.38725635
          C24.7754568,10.1554958 24.2103135,11.1792438 23.2374935,11.7940853 Z M21.3883319,13.9327539
          C20.7870756,13.9327539 20.3060706,14.4137589 20.3060706,15.0150152 C20.3060706,15.6162715 20.7870756,16.0972765 21.3883319,16.0972765
          C21.9895882,16.0972765 22.4705932,15.6162715 22.4705932,15.0150152 C22.4705932,14.4137589 21.9895882,13.9327539 21.3883319,13.9327539 Z"/>
      </svg>`,
    ),
  );
  matIcon.addSvgIconLiteral(
    'bulletin-board',
    sanitizer.bypassSecurityTrustHtml(
      `<svg style="width:24px;height:24px" viewBox="0 0 24 24">
        <path d="M12.04,2.5L9.53,5H14.53L12.04,2.5M4,7V20H20V7H4M12,0L17,5V5H20A2,2 0 0,1 22,7V20A2,2 0 0,1 20,22H4
          A2,2 0 0,1 2,20V7A2,2 0 0,1 4,5H7V5L12,0M7,18V14H12V18H7M14,17V10H18V17H14M6,12V9H11V12H6Z"/>
      </svg>`,
    ),
  );
}

export const provideIconInitializer = () =>
  provideAppInitializer(() => {
    const matIcon = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);
    registerIcons(matIcon, sanitizer);
  });
